var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEquityDividendIconCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64.3019C49.6731 64.3019 64 49.9074 64 32.1509C64 14.3945 49.6731 0 32 0C14.3269 0 0 14.3945 0 32.1509C0 49.9074 14.3269 64.3019 32 64.3019Z",
    fill: "#5F797B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_884_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 23.4483L46.4007 12L35.7912 17.2738L39.0771 18.8073L28.7373 40.1704L17.3594 30.3935L14 37.3631L31.2548 52L45.7305 21.9229L49 23.4483Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_884_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 40,
    fill: "white",
    transform: "translate(14 12)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityDividendIconCircle);
export default __webpack_public_path__ + "static/media/Equity_Dividend_Icon_circle.f719a5d9.svg";
export { ForwardRef as ReactComponent };